import { render, staticRenderFns } from "./PageSilder.vue?vue&type=template&id=b878861c&scoped=true"
import script from "./PageSilder.vue?vue&type=script&lang=js"
export * from "./PageSilder.vue?vue&type=script&lang=js"
import style0 from "./PageSilder.vue?vue&type=style&index=0&id=b878861c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../usr/local/node_16.9.1/lib/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b878861c",
  null
  
)

export default component.exports